import DOMPurify from "dompurify";

// Exposes the npm `dompurify` package as a global for legacy (non-module) jQuery
// scripts that reference `DOMPurify` directly (e.g. `DOMPurify.sanitize(...)`).
// This mirrors the ckeditor5 bundle pattern so the package.json version is the
// single source of truth instead of maintaining a separately checked-in
// `purify.min.js` file under public/assets/libs/dompurify.
declare global {
    interface Window {
        DOMPurify: typeof DOMPurify;
    }
}

window.DOMPurify = DOMPurify;
